var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLkr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8947 24 12.2673C24 5.63991 18.6274 0.267334 12 0.267334C5.37257 0.267334 0 5.63991 0 12.2673C0 18.8947 5.37257 24.2673 12 24.2673Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.39149 2.35327H5.23672C5.0526 2.47913 4.87241 2.61015 4.69583 2.74576L3.65234 12.2663L4.69583 21.7868C4.87241 21.9225 5.0526 22.0535 5.23672 22.1793H9.39149V2.35327Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2684C0 16.147 1.84069 19.5953 4.69567 21.7889V2.7478C1.84069 4.94146 0 8.38969 0 12.2684Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3047 7.58374V7.88425L19.3159 7.88594L19.3047 7.58374Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.044 15.3967H20.7831L19.8266 16.4402V18.5272H17.7396V17.4837H18.7831V15.3967H14.0874V16.7011H13.044V14.2152C12.7238 13.9287 12.5222 13.5124 12.5222 13.0489V6.26631C12.5222 5.40189 13.223 4.7011 14.0874 4.7011V14.3533H16.1744L16.8905 13.7565C16.7654 13.4586 16.6961 13.1315 16.6961 12.7881V11.2229H15.1309V8.09247H18.2613C18.2613 7.57075 19.044 7.04898 19.044 7.04898C19.044 7.04898 19.8266 7.5707 19.8266 8.09247V8.8751V11.2229C20.407 11.2298 21.3293 11.2148 22.3256 11.2229C22.0638 10.7654 21.9135 10.2226 21.9135 9.65772C21.9135 8.73705 22.311 7.90933 22.9437 7.33652C22.0317 5.3155 20.5764 3.59227 18.7639 2.35327H10.957V22.1794H18.764C20.968 20.6728 22.6437 18.4504 23.4567 15.847L23.044 15.3967Z",
    fill: "#A2001D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLkr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/LKR.0c3476c82438a16f914fe5d3dc59e828.svg";